import createArrayFromObject from "../helpers/create-array-from-object";

const KEY_LOCATIONS = "locations";

export default (data) => {
    data[KEY_LOCATIONS] = createArrayFromObject(data[KEY_LOCATIONS]);
    return data;
};
